import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText} from "@prismicio/react";
import { PrismicNextLink } from '@prismicio/next'

/**
 * Props for `NumberedPanels`.
 */
export type NumberedPanelsProps =
  SliceComponentProps<Content.NumberedPanelsSlice>;

/**
 * Component for "NumberedPanels" Slices.
 */
const NumberedPanels: FC<NumberedPanelsProps> = ({ slice }) => {

  let theme ="";

  switch(slice.primary.theme) {
    case 'Grey':
      theme ="bg-lightgrey";
    break;
    case 'Jade':
      theme ="bg-jadetint";
    break;
    case 'Orange':
      theme ="bg-orangetint border-t-[72px] border-t-orange";
    break;
    default: theme ="";
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${theme} font-fellix px-4 md:px-8 lg:px-16`}
    >
      <div className="max-w-[1220px] mx-auto text-center">
        <div className={slice.primary.no_padding === true ? "" : "py-24"}>
          <article className="text-[32px] leading-9 text-center mb-[25px] font-semibold prose prose-h2:text-[32px]! prose-h2:leading-9!">
            <PrismicRichText field={slice.primary.title} />
          </article>
          <article className="text-[20px] leading-[26px] font-normal mb-[109px] text-center max-w-[650px] ml-auto mr-auto">
            <PrismicRichText field={slice.primary.paragraph} />
          </article>
          <div className="grid grid-cols-12 gap-4 mt-24">
            {slice.primary.panel_content.map((item: any, index: number)=>{
                return (
                    <div className={`col-span-12 ${slice.primary.panel_content?.length === 4 ? "md:col-span-3" : "md:col-span-4"} text-left w-full relative pb-[100px]`} key={index}>
                      {slice.primary?.column_rules && (<div className="border-t-orange border-t-4 pt-8 md:mr-[20%]"></div>)}
                      <article className="prose prose-a:text-blue prose-h6:text-[18px] prose-h6:font-semibold prose-a:hover:underline prose-a:no-underline prose-p:text-[14px] leading-[22px] prose-h3:text-[100px] prose-h3:text-orange prose-h3:font-normal prose-h3:leading-[60px] prose-h3:m-0 prose-h3:mb-12 prose-h4:text-[20px] prose-h4:leading-7 lg:pr-20">
                        <PrismicRichText field={item.panel_content} />
                      </article>
                      <div className=" bottom-0 w-full">
                      {item.link_1?.link_type !=="Any" ? // This one is an internal link to a prismic page
                        <PrismicNextLink className="button w-full max-w-[80%] mt-8 mb-4 leading-[18px] text-center" field={item.link_1}>
                          {item.link_text_1}
                        </PrismicNextLink>
                      : <></> }
                      {item.link_2?.link_type !=="Any" ? // This one is an internal link to a prismic page
                        <PrismicNextLink className="button w-full max-w-[80%] mb-4 leading-[18px] text-center" field={item.link_2}>
                          {item.link_text_2}
                        </PrismicNextLink>
                      : <></> }
                      {item.buton_link_3?.link_type !=="Any" ? // This one is an internal link to a prismic page
                        <PrismicNextLink className="button w-full max-w-[80%] mb-4 leading-[18px] text-center" field={item.buton_link_3}>
                          {item.link_text_3}
                        </PrismicNextLink>
                      : <></> }
                      </div>
                    </div>
                )
            })}
            </div>
            <div className="fineprint">
              <PrismicRichText field={slice.primary.fineprint}/>
            </div>
        </div>
      </div>
    </section>
  );
};

export default NumberedPanels;
